import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import iview from 'iview'
import BaiduMap from 'vue-baidu-map'
import '@babel/polyfill'
// import Add2Home from './pwa/Add2Home'
// import 'iview/dist/styles/iview.css'
import '@/assets/less/app.less'
import '@/assets/sass/app.scss'

// 引入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestionCircle,fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(faQuestionCircle,fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// 禁止ios10以上可以缩放屏幕
window.onload = function () {
  // 阻止双击放大
  var lastTouchEnd = 0
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)
  // 阻止双指放大
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })

  // 清空标题栏
  document.title = '\u200E'
}

// 消息全局配置
iview.Message.config({
  top: 300,
  duration: 6
})

// 百度地图 key
const ak = 'cYvZCrpa13tXvOuQTzoctGZI'

// 注册 service worker dell_customer
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/dell_customer/dell-sw.js').then((registration) => {
    console.log('Service workder register...', registration)
    // Add2Home() // 监听添加到主屏幕横幅弹出事件，并获取用户操作，暂未生效
  }).catch(err => {
    console.log('[Service Worker register ERROR]: ' +
      err)
  })
}

Vue.use(iview)
// 使用 vue 百度地图组件
Vue.use(BaiduMap, {
  ak
})

axios.defaults.withCredentials = false

// 使用 axios
Vue.use(VueAxios, axios)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
